import React from 'react';
import { blackDot, blackDotSplitter } from '../../../assets/svg';

interface IProps {
  containerClassName: string;
  dotsContainerClassName: string;
  dotsAmount: number;
  dotsInGroup: number;
}

const BlackDotContainer = ({
  dotsAmount, dotsInGroup, containerClassName, dotsContainerClassName,
}:IProps) => {
  const countDotsAmountForLastContainer = () => {
    let res = dotsAmount;
    while (res > dotsInGroup) res -= dotsInGroup;
    return res;
  };
  const groupContainers = Array(Math.ceil(dotsAmount / dotsInGroup)).fill('').map((v, i) => `dotContainer${i}`);
  const dotsInContainer = Array(dotsInGroup).fill('').map((v, i) => `dot${i}`);
  const dotsInLastContainer = countDotsAmountForLastContainer();
  return (
    <div className={containerClassName}>
      {groupContainers.map((container, iC) => (
        <div key={`${container}`} className={`flex h-full items-center ${dotsContainerClassName}`}>
          {dotsInContainer.map((el, iD) => {
            if (iC === groupContainers.length - 1 && iD > dotsInLastContainer - 1) return null;
            return <img className='w-[8px] h-[8px] mr-[5px]' key={`${el}`} src={blackDot} alt='blackDot' />;
          })}
          <img src={blackDotSplitter} alt='blackDotSplitter' className='mr-[5px]' />
        </div>
      ))}
    </div>
  );
};

export default BlackDotContainer;
